// extracted by mini-css-extract-plugin
export default {"root":"Challenges_root__oKZfp","subTitle":"Challenges_subTitle__CyyIl","title":"Challenges_title__aM5UK","categories":"Challenges_categories__UmHQY"};